import moment from "moment";
import { technicianTypes, status } from "./default";
import { mapGetters } from "vuex";

export default {
  computed: {
    isAdmin() {
      return this.$store.getters.user.role == 1;
    },
    isDispatcher() {
      return this.$store.getters.user.role == 2;
    },
    isDataEntry() {
      return this.$store.getters.user.role == 3;
    },
    isDataEntryAndDispatcher() {
      return this.$store.getters.user.role == 4;
    },
    is_mobile() {
      return window.innerWidth < 768;
    },
    ...mapGetters(["fieldConditions"]),
  },
  methods: {
    getJobStatus(doc) {
      let item = status.find((item) => {
        return item.value == doc.status;
      });
      return item instanceof Object ? item.name : "";
    },

    getTechnicianType({ type }) {
      let item = technicianTypes.find((item) => {
        return item.value == type;
      });
      return item != null ? item.name : "";
    },
    getTechStatus({
      technician_accept_status,
      technician_accept_at,
      technician_reject_at,
    }) {
      if (technician_accept_status == "accept") {
        return `ACCEPT<br/>${moment(technician_accept_at).format("hh:mm A")}`;
      }
      if (technician_accept_status == "reject") {
        return `REFUSE<br/>${moment(technician_reject_at).format("hh:mm A")}`;
      }
      return "";
    },
  },
};
